import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import Select from 'react-select';
import { Modal } from 'react-bootstrap';

import StaffRfmsReportViewModal from './StaffRfmsReportViewModal';

// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import getLocale from '../../i18n/getLocale';

class StaffRfmsReportSiglaAvaliation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      modal: false,
      data: [],
      errors_listing: false,
      errors_messages: [],
      data_report_fatigues: [],
      staff_name: ''
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.ActionsButtons = this.ActionsButtons.bind(this);
    this.loadData = this.loadData.bind(this);
    this.import = this.import.bind(this);
    this.showModal = this.showModal.bind(this);

    this.locale = getLocale();
  }

  // Handlers
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }


  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData () {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/relatorios-de-fadiga/listagens';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({
            applicabilities_list: responseJson.data.applicabilities_list,
          });
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
      }); /* Overlay */
    });
  }

  import(event) {
    event.preventDefault();
    var self = this;
    var data = new FormData();
    var csv_file = document.querySelector(`.filecsv`).files[0];
    data.append("file", csv_file);
    data.append("applicability_id",  this.state.applicability_id);
    data.append("simulation",  1);
    var header = this.refs.request_api.header();
    this.handleAlert('', '', 'open');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/importar/sigla', {
        method: 'POST',
        mode: 'cors',
        headers: value,
        body: data }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          if (responseJson.status === 'success') {
            self.handleAlert(responseJson.message, responseJson.status, 'open');
            self.setState({
              modal: false,
              file: undefined,
              import_alerts: undefined,
              staff_rfms_reports: responseJson.data,
            });
          } else {
            self.setState({
              import_alerts: responseJson.data,
              file: undefined,
            });
            self.handleAlert('', '', 'closed');
          }
        }).catch((error) => {
          console.error(error);
        });
      });   
    }
    
    
  showModal(row) {
    this.setState({
      staff_name: row.staff_name,
      data_report_fatigues: row,
      modal_props: true,
    });
  }

  ActionsButtons (cell, row) {
    var botao = (
      <div className="btn-group">
        <button className="btn btn-sm btn-info" onClick={() => this.showModal(row)}>
          <i className="fa fa-fw fa-eye"></i>
        </button>
      </div>
    );

    return botao;
  }


  render() {
    var self = this;
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title">{this.locale.RelatoriosDeFadiga.AvaliarEscalaPlanejada.titulo}</h3>
      <hr/>
      <form onSubmit={this.import}>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.RelatoriosDeFadiga.AvaliarEscalaPlanejada.formulario.Aplicabilidade}:</label>
              <Select
                className="form-field-name"
                name="applicability_id"
                value={this.state.applicability_id}
                searchable={true}
                required
                placeholder={this.locale.RelatoriosDeFadiga.AvaliarEscalaPlanejada.formulario.placeholder.SelecionarAplicabilidade}
                onChange={this.handleSelectChange.bind(this, 'applicability_id')}
                options={this.state.applicabilities_list}
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.RelatoriosDeFadiga.AvaliarEscalaPlanejada.formulario.Arquivo}:</label>
              <input type="file" name="archive" className={"form-control filecsv"} placeholder={this.locale.RelatoriosDeFadiga.AvaliarEscalaPlanejada.formulario.placeholder.Arquivo} value={this.state.archive} onChange={this.handleChange.bind(this, 'archive')} />
            </div>
          </div>
        </div>
        <hr/>
        {
        (typeof self.state.import_alerts !== 'undefined') ?
          <div>
            <h4><strong>{this.locale.RelatoriosDeFadiga.AvaliarEscalaPlanejada.formulario.tituloErrosDeImportacao}:</strong></h4>
            {Object.keys(self.state.import_alerts).map(function(k) {
              var alert = self.state.import_alerts[k];
              return(
                <div className={"box-alert box-alert-danger"}>
                    <div dangerouslySetInnerHTML={{__html: alert}}></div>
                </div>
              );
            })}
            <hr/>
          </div>
        :
          ''
        }
        <div>
          <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-upload"></i> {this.locale.RelatoriosDeFadiga.AvaliarEscalaPlanejada.formulario.botaoImportar}</button>
        </div>
      </form>
      <div>
        <hr/>
        <BootstrapTable data={this.state.staff_rfms_reports} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.RelatoriosDeFadiga.AvaliarEscalaPlanejada.tabela.semParametrosDeFadiga}} search={true} multiColumnSearch={true}  searchPlaceholder={this.locale.general.procurar}>

          <TableHeaderColumn isKey={true} dataField="date_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.RelatoriosDeFadiga.AvaliarEscalaPlanejada.tabela.Data}</TableHeaderColumn>
          <TableHeaderColumn dataField="revision" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.RelatoriosDeFadiga.AvaliarEscalaPlanejada.tabela.Revisao}</TableHeaderColumn>
          <TableHeaderColumn dataField="staff_name" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.RelatoriosDeFadiga.AvaliarEscalaPlanejada.tabela.Tripulante}</TableHeaderColumn>
          <TableHeaderColumn dataField="day_off_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.RelatoriosDeFadiga.AvaliarEscalaPlanejada.tabela.Folga}</TableHeaderColumn>
          <TableHeaderColumn dataField="actual_points_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.RelatoriosDeFadiga.AvaliarEscalaPlanejada.tabela.QuantidadeDePontosAtual}</TableHeaderColumn>
          <TableHeaderColumn dataField="report_points_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.RelatoriosDeFadiga.AvaliarEscalaPlanejada.tabela.QuantidadeDePontosReportados}</TableHeaderColumn>
          <TableHeaderColumn dataField={'fatigue_event_str'} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='120'>{this.locale.RelatoriosDeFadiga.AvaliarEscalaPlanejada.tabela.Status}</TableHeaderColumn>

          <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.ActionsButtons} width='100'>{this.locale.RelatoriosDeFadiga.AvaliarEscalaPlanejada.tabela.Acoes}</TableHeaderColumn>

        </BootstrapTable>
        <StaffRfmsReportViewModal handleAlert={self.props.handleAlert} modal_props={self.state.modal_props} staff_name={self.state.staff_name} data_report_fatigues={self.state.data_report_fatigues} simulation={1} />
      </div>
    </div>
  </div>
</div>
    );
  }
}

export default StaffRfmsReportSiglaAvaliation;



// WEBPACK FOOTER //
// ./src/Components/StaffRfmsReport/StaffRfmsReportSiglaAvaliation.js